import type { Puzzle } from "../types.ts";

export function calculateStars(moveCount: number, puzzle: Puzzle): 1 | 2 | 3 {
  if (moveCount <= puzzle.optimalMoves) return 3;
  if (moveCount <= puzzle.optimalMoves + 2) return 2;
  return 1;
}
